const key = (name: string) => `debug:${name}`;
const cache = new Map<string, boolean>();

function getStorage(): Storage | null {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage;
  } catch {
    return null;
  }
}

export function isDebugEnabled(name: string): boolean {
  let value = cache.get(name);
  if (value === undefined) {
    try {
      value = getStorage()?.getItem(key(name)) === 'true';
    } catch {
      value = false;
    }
    cache.set(name, value);
  }
  return value;
}

export function setDebugEnabled(name: string, enabled: boolean) {
  cache.set(name, enabled);

  try {
    const storage = getStorage();
    if (!storage) return;

    if (enabled) {
      storage.setItem(key(name), 'true');
    } else {
      storage.removeItem(key(name));
    }
  } catch {

  }
}
